export function isFocusUnclaimed(active: Element | null): boolean {
    return active === null || active === document.body
}

export function isFocusInside(
    container: Element | null,
    active: Element | null
): boolean {
    return container !== null && active !== null && container.contains(active)
}
